import { ItemSaleSuggestionState } from './types';

export const defaultState: ItemSaleSuggestionState = {
  error: undefined,
  loading: {
    create: false
  }
};
